<template>
  <div>
    <integrationNipModal ref="integrationNipModal" :defaultNip="defaultNip" @handlerNipClose="handlerNipClose" />
    <a-form id="my_form_styl" v-if="true" :form="form" layout="vertical">
      <a-form-item :label="$t('Status')">
        <h3 style="font-weight: bold">
          <a-tag color="#029C8E" v-if="document.status != 'DO OPISANIA'">{{
          document.status != undefined ? $t(document.status) : $t("NOWY")
          }}</a-tag>
          <a-tag color="#FCB76F" v-else>{{ $t("DO OPISANIA") }}</a-tag>
        </h3>
      </a-form-item>

      <a-form-item :label="$t('File name')">
        <a-tooltip>
          <template slot="title">
            <span>{{ document.NAME }}</span>
          </template>
          <span>{{ document.NAME }}</span>
        </a-tooltip>
      </a-form-item>

      <a-form-item :label="$t('Date of receiving')">
        <span v-if="currentEdit">
          <a-date-picker @change="changePromptStatus" :disabled="disableFromResponsible || !currentEdit" v-decorator="[
            'date_send',
            {
              rules: [
                {
                  required: true,
                  message: $t('Date of receiving') + $t('required_field'),
                },
              ],
              initialValue:
                document.date_send != undefined && document.date_send != ''
                  ? moment(document.date_send, 'YYYY-MM-DD')
                  : '',
            },
          ]" />
        </span>
        <span v-else>{{ document.date_send }}</span>
      </a-form-item>

      <a-form-item :label="$t('Document type')">
        <a-select @change="changePromptStatus" showSearch :disabled="disableFromResponsible || !currentEdit"
          optionFilterProp="children" v-decorator="[
            'document_type',
            {
              rules: [
                {
                  required: true,
                  message: $t('Document type') + $t('required_field'),
                },
              ],
              initialValue: $t(document.document_type),
            },
          ]">
          <a-select-option value="Dokument zwykly">{{
          $t("Regular document")
          }}</a-select-option>
          <a-select-option value="Dokument poufny">{{
          $t("Сonfidential document")
          }}</a-select-option>
          <a-select-option value="FVZ">{{ $t("Invoice") }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :label="$t('Document name')">
        <span v-if="flagDocName && !disableFromResponsible && currentEdit" @click="flagDocName = !flagDocName"
          style="display: flex; cursor: pointer">
          <div style="white-space: nowrap; overflow: hidden">
            {{ document.title != undefined ? document.title : "" }}
          </div>
          <div>
            <i class="fa fa-pencil" style="font-size: 14px; margin-left: 15px; color: gray"></i>
          </div>
        </span>
        <span v-else-if="disableFromResponsible || !currentEdit">{{
        document.title
        }}</span>
        <a-input @change="changePromptStatus" v-else v-decorator="[
          'title',
          {
            rules: [{ required: false }],
            initialValue: document.title != undefined ? document.title : '',
          },
        ]" />
      </a-form-item>

      <a-form-item :label="$t('main_company_n_hub')">
        <a-input @change="changePromptStatus" @click="handleChangeMyCompany()"
          :disabled="disableFromResponsible || !currentEdit" v-model="myCompanyTitle" />
        <!-- <a-select
        @change="changePromptStatus"
        @click="handleChangeDeal()"
        showSearch
        :disabled="disableFromResponsible || !currentEdit"
        optionFilterProp="children"
        v-decorator="[
          'my_company',
          {
            rules: [
              {
                required: true,
                message: $t('main_company_n_hub') + $t('required_field'),
              },
            ],
            initialValue: document.my_company,
          },
        ]"
      >
        <a-select-option v-for="comp in info.my_company" :key="comp.ID">
  
          {{ comp.TITLE }} /
          {{
            Array.isArray(comp[user_setup.nip_field])
              ? comp[user_setup.nip_field][0]
              : typeof comp[user_setup.nip_field] == "string"
              ? comp[user_setup.nip_field]
              : ""
          }}
        </a-select-option>
      </a-select>-->
      </a-form-item>

      <!-- <a-form-item :label="$t('Contractor') + ' / NIP'"> -->
      <a-form-item :label="$t('Contractor')">
        <a-row>
          <a-col :span="22">
            <a-input @change="changePromptStatus" @click="handleChangeContractor()"
              :disabled="disableFromResponsible || !currentEdit" v-model="contactorTitle" />
            <!--<a-select
            @change="changePromptStatus"
            showSearch
            :disabled="disableFromResponsible || !currentEdit"
            optionFilterProp="children"
            @dropdownVisibleChange="companyUpdate"
            v-decorator="[
              'kontragent',
              {
                rules: [
                  {
                    required: true,
                    message: $t('Contractor') + ' / HUB' + $t('required_field'),
                  },
                ],
                initialValue: document.kontragent,
              },
            ]"
          >
            <a-select-option v-for="comp in info.company" :key="comp.ID">
             
              {{ comp.TITLE }} /
              {{
                Array.isArray(comp[user_setup.nip_field])
                  ? comp[user_setup.nip_field][0]
                  : typeof comp[user_setup.nip_field] == "string"
                  ? comp[user_setup.nip_field]
                  : ""
              }}
            </a-select-option>
          </a-select>
          -->

            <a-button @click="$refs.integrationNipModal.showModal()" type="primary" icon="plus" />
            <!-- <a v-show="info.nip" :href="`https://${domain}/marketplace/app/${info.nip}/`" target="_blank"
              style="padding-left: 5px">
              <a-icon type="plus-circle" />
            </a> -->
          </a-col>
        </a-row>
      </a-form-item>

      <a-form-item :label="$t('File creation date')">
        <span>{{ document.CREATE_TIME.slice(0, 10) }}</span>
      </a-form-item>

      <a-form-item :label="$t('ID document')">
        <span>{{ document.ID }}</span>
      </a-form-item>

      <!-- <a-modal
      v-model="showFormValidationErrorModal"
      @ok="showFormValidationErrorModal = false; ignoreErrorsAndSubmit()"
      @cancel="showFormValidationErrorModal = false; onback()"
      :okText="$t('Save')"
      :cancelText="$t('Close without saving')"
      centered
    >
      <p>{{ $t('fields are successfully filled') }}</p>
      <p>{{ $t('what_to_do') }}</p>
    </a-modal>-->
      <a-modal v-model="showFormValidationErrorModal" @ok="
        showFormValidationErrorModal = false;
        ignoreErrorsAndSubmit();
      " @afterClose="showFormValidationErrorModal = false" @cancel="showFormValidationErrorModal = false"
        :okText="$t('SaveModal')" :cancelText="$t('Back to editing')" centered>
        <p>{{ $t("fields are successfully filled") }}</p>
      </a-modal>

      <!-- <a-modal
      v-model="showFormValidationErrorModalForFail"
      @ok="showFormValidationErrorModalForFail = false;"
      @afterClose="showFormValidationErrorModalForFail = true;"
      @cancel="showFormValidationErrorModalForFail = false; onback()"
      :okText="$t('Back to editing')"
      :cancelText="$t('Close without saving')"
      centered
    >
      <p>{{ $t('mandatory_fields_r_unfilled') }}</p>
      <p>{{ $t('what_to_do') }}</p>
    </a-modal>-->
      <a-modal v-model="showFormValidationErrorModalForFail" @ok="
        showFormValidationErrorModalForFail = false;
        ignoreErrorsAndSubmit();
      " @afterClose="showFormValidationErrorModalForFail = false" @cancel="
        showFormValidationErrorModalForFail = false;
        onback();
      " :okText="$t('Save')" :cancelText="$t('Close without saving')" centered>
        <p>{{ $t("mandatory_fields_r_unfilled") }}</p>
        <p>{{ $t("what_to_do") }}</p>
      </a-modal>
    </a-form>
  </div>
</template>
<script>
import moment from "moment";
import { requestStep } from "../requestFunc";
import integrationNipModal from "@/components/integrationNipModal";
import { mapGetters } from "vuex";
export default {
  props: [
    "document",
    "info",
    "disableFromResponsible",
    "commentsData",
    "currentEdit",
    "user_setup",
    "isPromptAvailableParent",
  ],
  components: {
    integrationNipModal,
  },
  data() {
    return {
      // nip_field_for_company: "",
      domain: null,
      defaultNip: "",
      isNipVisible: false,

      form: this.$form.createForm(this, { name: "first_set" }),
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 9 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      myCompany: '',
      contractor: '',
      myCompanyTitle: '',
      contactorTitle: '',
      flagDocName: true,
      file:
        this.document != null
          ? this.document
          : { ID: "", CREATE_TIME: "", TYPE: "" },
      showFormValidationErrorModal: false,
      showFormValidationErrorModalForFail: false,
    };
  },
  computed: { ...mapGetters(["companyFieldForNIP"]) },
  methods: {
    moment,
    handlerNipClose() {
      // if (companyID) {
      //   if (this.COMPANY_LIST[companyID]) {
      //     this.form.setFieldsValue({
      //       kontragent: companyID.toString(),
      //     });
      //   } else {
      //     BX24.callMethod("crm.company.get", { id: companyID }, (result) => {
      //       if (result.error()) console.error(result.error());
      //       else {
      //         let companyInfo = result.data();
      //         this.info.company.splice(0, 0, companyInfo);
      //         this.COMPANY_LIST = Object.assign({}, this.COMPANY_LIST, {
      //           [companyID]: companyInfo,
      //         });
      //         this.form.setFieldsValue({
      //           kontragent: companyInfo.ID,
      //         });
      //       }
      //     });
      //   }
      // }
    },
    changePromptStatus() {
      if (!this.isPromptAvailableParent) {
        this.isPromptAvailableParent = true;
        this.$emit("changePromptStatus", this.isPromptAvailableParent);
      }
    },
    handleChangeMyCompany() {
      // eslint-disable-next-line
      BX24.selectCRM({
        entityType: ['company'],
        multiple: false
      }, (info) => {
        console.log(info, 'info');
        this.myCompany = info.company[0].id.split('_')[1];
        this.myCompanyTitle = info.company[0].title;
        console.log(this.myCompany, 'this.myCompany');
        console.log(this.myCompanyTitle, 'this.myCompanyTitle');
      })
    },
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM({
        entityType: ['company'],
        multiple: false
      }, (info) => {
        console.log(info, 'info');
        this.contractor = info.company[0].id.split('_')[1];
        this.contactorTitle = info.company[0].title;
        console.log(this.contractor, 'this.myCompany');
        console.log(this.contactorTitle, 'this.myCompanyTitle');
      })
    },
    companyUpdate(open) {
      let vm = this;
      if (open) {
        // eslint-disable-next-line
        BX24.callMethod(
          "crm.company.list",
          {
            filter: {
              ">ID": vm.info.company[vm.info.company.length - 1].ID,
            },
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              let res = result.data();
              vm.info.company = vm.info.company.concat(res);

              if (result.more()) result.next();
              else {
                vm.info.company = vm.info.company.filter(
                  (el, i) =>
                    vm.info.company.findIndex((x) => x.ID == el.ID) == i
                );
              }
            }
          }
        );
      }
    },
    ignoreErrorsAndSubmit(comments = this.comments) {
      this.form.validateFields((err, values) => {
        console.log("values in first tab:");
        console.log(values);
        console.log("values in first tab:");
        if (err) {
          this.changeSpinning();
          requestStep(this.saveValues(values, comments))
            .done((data) => {
              var res = JSON.parse(data);
              this.document.status = res.status;
              this.document.title =
                values.title != undefined
                  ? values.title
                  : this.document.title != undefined
                    ? this.document.title
                    : "";
              if (res.status == "DO OPISANIA") {
                this.$message.success(this.$t("document_registration_done"));
              } else {
                this.$message.success(
                  this.$t("Status") + " " + this.$t("NOWY")
                );
              }
            })
            .fail((e) => {
              console.error(e);
              this.$message.error(this.$t("document_registration_fail"));
            })
            .always(() => {
              this.changeSpinning();
              this.onback();
            });
          // return;
        } else {
          this.changeSpinning();
          requestStep(this.saveValues(values, comments))
            .done((data) => {
              var res = JSON.parse(data);
              this.document.status = res.status;
              this.document.title =
                values.title != undefined
                  ? values.title
                  : this.document.title != undefined
                    ? this.document.title
                    : "";
              this.$message.success(this.$t("document_registration_done"));
            })
            .fail((e) => {
              console.error(e);
              this.$message.error(this.$t("document_registration_fail"));
            })
            .always(() => {
              this.changeSpinning();
              this.onback();
            });
        }
      });
    },
    submit(comments) {
      this.form.validateFields((err) => {
        if (err) {
          this.showFormValidationErrorModalForFail = true;
        } else {
          this.showFormValidationErrorModal = true;
        }
      });

      this.comments = comments;
    },
    saveValues(values, comments) {
      if (
        values.date_send != undefined &&
        values.date_send != "" &&
        values.date_send != "Invalid date"
      ) {
        values.date_send = moment(values.date_send).format("YYYY-MM-DD");
      } else {
        values.date_send = "";
      }

      let data = {
        run: "savedocumentstage1",
        title: this.document.title != undefined ? this.document.title : "",
        date_send: values.date_send,
        CREATE_TIME: this.document.CREATE_TIME,
        document_type: values.document_type,
        comments: comments,
        name: this.document.NAME,
        my_company: this.myCompany,
        kontragent: this.contractor,
        ID: this.document.ID,
        url: this.document.DOWNLOAD_URL,
        DETAIL_URL: this.document.DETAIL_URL,
      };
      for (let key in values) {
        if (values[key] != this.document[key]) {
          data[key] = {
            old: this.document[key],
            new: values[key],
          };
        }
      }
      return data;
    },
    onback() {
      this.$emit("onback", {
        unshift_elem: true,
        remove_elem: this.document.ID,
      });
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    showDrawer() {
      this.isNipVisible = true;
    },
    onClose() {
      this.isNipVisible = false;
    },
  },
  mounted() {

    // console.log("user fields");
    // this.nip_field_for_company = this.info.userfields.filter(elem => {
    //   if (elem.title == this.user_setup.nip_field) {
    //     return elem;
    //   }
    // })[0].listLabel;

    // console.log(this.nip_field_for_company);

    // eslint-disable-next-line
    let auth = BX24.getAuth();
    this.domain = auth.domain;
    // eslint-disable-next-line
    BX24.fitWindow();
  },
};
</script>

<style scoped>
.first_form label {
  font-weight: 500;
}
</style>